import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import {
  getAuth,
  GoogleAuthProvider,
  setPersistence,
  browserLocalPersistence,
} from 'firebase/auth';

// MISMO proyecto Firebase que rocharamascnc: compartimos la base de datos.
// Las colecciones de este chat van prefijadas con `chat_` para no colisionar
// con las de rocharamascnc (users, secuencias_automaticas, controlRemoto, ...).
const firebaseConfig = {
  apiKey: 'AIzaSyBn80DXQu8-H8HHl6PzARAlSwv-3aAO1Q0',
  authDomain: 'rocharamascnc.firebaseapp.com',
  projectId: 'rocharamascnc',
  storageBucket: 'rocharamascnc.firebasestorage.app',
  messagingSenderId: '496193550382',
  appId: '1:496193550382:web:efd6d86ba0703e2134c7bf',
  measurementId: 'G-QY0VFBBCEQ',
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);

// Mantener la sesión guardada en el dispositivo: el cliente no vuelve a
// recibir códigos ni a iniciar sesión hasta que cierre sesión manualmente,
// incluso después de cerrar y reabrir el navegador.
setPersistence(auth, browserLocalPersistence).catch((e) =>
  console.error('No se pudo fijar la persistencia de sesión:', e)
);

const googleProvider = new GoogleAuthProvider();

// Correo del único administrador autorizado.
export const ADMIN_EMAIL = 'rodolfomdelarocha@gmail.com';

export { app, db, storage, auth, googleProvider };
